export class DashboardInicializacionModel {
    public idNPanel: number | null;
    public fldTPosicionZona: string | null;
    public fldNPosicionOrden: number | null;
    public fldTPanelTipo: string | null;
    public fldTPanelColor: string | null;
    public fldTPanelColorFondo: string | null;
    public fldTPanelTitulo: string | null;
    public fldTPanelTituloColor: string | null;
    public fldTPanelTituloColorFondo: string | null;
    public fldBGrafico: boolean | null;
    public fldTGraficoTitulo: string | null;
    public fldTGraficoTituloColor: string | null;
    public fldTGraficoTituloColorFondo: string | null;
    public fldBDetalle: boolean | null;
    public fldTDetalleColor: string | null;
    public fldTDetalleColorFondo: string | null;
    public fldTDetalleTitulo: string | null;
    public fldTDetalleTituloColor: string | null;
    public fldTDetalleTituloColorFondo: string | null;
    public fldBDetalleConEnlace: boolean | null;
    public fldBVerTiendas: boolean | null;
    public fldTVerTiendasTitulo: string | null;

    constructor(data: any) {
        this.idNPanel = null;
        this.fldTPosicionZona = null;
        this.fldNPosicionOrden = null;
        this.fldTPanelTipo = null;
        this.fldTPanelColor = null;
        this.fldTPanelColorFondo = null;
        this.fldTPanelTitulo = null;
        this.fldTPanelTituloColor = null;
        this.fldTPanelTituloColorFondo = null;
        this.fldBGrafico = null;
        this.fldTGraficoTitulo = null;
        this.fldTGraficoTituloColor = null;
        this.fldTGraficoTituloColorFondo = null;
        this.fldBDetalle = null;
        this.fldTDetalleColor = null;
        this.fldTDetalleColorFondo = null;
        this.fldTDetalleTitulo = null;
        this.fldTDetalleTituloColor = null;
        this.fldTDetalleTituloColorFondo = null;
        this.fldBDetalleConEnlace = null;
        this.fldBVerTiendas = null;
        this.fldTVerTiendasTitulo = null;

        Object.assign(this, data);
    }
}

export class DashboardPanelIcoValor2Model {
    fkNPanel: number | null;
    fldTLeftTitulo: string | null;
    fldTLeftTituloColor: string | null;
    fldTLeftQueryColor: string | null;
    fldTLeftQueryCount: string | null;
    fldTRightTitulo: string | null;
    fldTRightTituloColor: string | null;
    fldTRightQueryCount: string | null;
    fldTRightQueryColor: string | null;
    constructor(data: any) {
        this.fkNPanel = null;
        this.fldTLeftTitulo = null;
        this.fldTLeftTituloColor = null;
        this.fldTLeftQueryColor = null;
        this.fldTLeftQueryCount = null;
        this.fldTRightTitulo = null;
        this.fldTRightTituloColor = null;
        this.fldTRightQueryCount = null;
        this.fldTRightQueryColor = null;
        Object.assign(this, data);
    }
}

export class DashboardPanelIcoValorModel {

    fkNPanel: number | null;
    fkNIcono: number | null; 
    fldTQueryColor: string | null;
    fldTQueryCount: string | null;
    constructor(data: any) {
        this.fkNPanel = null;
        this.fkNIcono = null;
        this.fldTQueryColor = null;
        this.fldTQueryCount = null;
        Object.assign(this, data);
    }
}

export class DashboardPanelLista3CModel {
    idNKey: number | null;
    fldTColumna_1: string | null;
    fldTColumna_2: string | null;
    fkNIcono: number | null;
    fldBPortada: boolean | null;

    constructor(data: any) {
        this.idNKey = null;
        this.fldTColumna_1 = null;
        this.fldTColumna_2 = null;
        this.fkNIcono = null;
        this.fldBPortada = null;

        Object.assign(this, data);
    }
    
}

export class DashboardLinkPopUpModel {
    fldTValores: string | null;
    fldTSubValores: string | null;
    fldTSubSubValor: string | null;

    constructor(data: any) {
        this.fldTValores = null;
        this.fldTSubValores = null;
        this.fldTSubSubValor = null;
        Object.assign(this, data);
    }
}
